import React, { useCallback } from 'react'
import { BookCard } from 'components/BookCard'
import { LevelUpCard } from 'components/LevelUpCard'
import { getBookModeFromBookType } from 'store/services/Book'
import { LearningJourneyEntityType } from 'store/services/Journey'
import { LevelUpType, StoreShelfEntry } from 'store/services/Library'

type LibraryItemProps = {
  isRecommended?: boolean
  item: StoreShelfEntry
  onClick: (item: StoreShelfEntry) => void
  itemRef?: (element: HTMLElement | null) => HTMLElement | null
  onFocus?: () => void
  tabIndex?: number
}

export const LibraryItem = ({ isRecommended, item, onClick, itemRef, onFocus, tabIndex }: LibraryItemProps) => {
  const _onClick = useCallback(() => onClick(item), [onClick, item])

  switch (item.type) {
    case LearningJourneyEntityType.LevelUp: {
      return (
        <LevelUpCard
          tabIndex={tabIndex}
          onFocus={onFocus}
          itemRef={itemRef}
          onClick={_onClick}
          levelUpType={item.data.subtype === 'sentence' ? LevelUpType.SENTENCE_BUILDER : LevelUpType.WORD_CRAFT}
        />
      )
    }
    case LearningJourneyEntityType.Book: {
      return (
        <BookCard
          tabIndex={tabIndex}
          onFocus={onFocus}
          itemRef={itemRef}
          isRecommended={isRecommended}
          book={item.data}
          attributes={item.attributes}
          onClick={_onClick}
          bookMode={getBookModeFromBookType(item.data.book.bookType)}
        />
      )
    }
    default:
      return null
  }
}
